import { render } from "./HeroiconsOutlinePhoneOutgoing.vue?vue&type=template&id=4b87d51d"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePhoneOutgoing.vue"]])

export default __exports__